import type { ChangeEvent} from "react";
import { useState } from "react";
import { useAppDispatch } from "../../../services/redux/hooks/use-dispatch";
import { createResearchAction } from "../redux/actions";

export const useResearchInput = () => {
  const dispatch = useAppDispatch();
  const [input, setInput] = useState<string>("");

  const handleChangeInput = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setInput(event.target.value);
  };

  const handleSendTask = () => {
    dispatch(createResearchAction({ input }));
    setInput("");
  };

  const handleSendTaskWithKeyDown = (
    event: React.KeyboardEvent<HTMLTextAreaElement>
  ) => {
    if (event.ctrlKey && event.key === "Enter") {
      event.preventDefault();
      handleSendTask();
      setInput("");
    }
  };

  return {
    input,
    handleChangeInput,
    handleSendTask,
    handleSendTaskWithKeyDown,
  };
};
